import { render, staticRenderFns } from "./ReleaseKit.vue?vue&type=template&id=5973d32a&scoped=true"
import script from "./ReleaseKit.vue?vue&type=script&lang=js"
export * from "./ReleaseKit.vue?vue&type=script&lang=js"
import style0 from "./ReleaseKit.vue?vue&type=style&index=0&id=5973d32a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973d32a",
  null
  
)

export default component.exports